import React, { useEffect, useState } from 'react';
import '../styles/manual-trip.style.scss';
import { EasyTripCreateComponent } from '../components/trips-component/trips-root-component/easy-trip-create-component';
import { useLocation } from 'react-router-dom';
import { getUrlVars, isValid } from '../utils/utilities';

export const EasyTripsPage = (props) => {

    const location = useLocation()

    const [scheduleId, setScheduleId] = useState(null);

    useEffect(() => {
        if (isValid(location.state) && isValid(location.state.scheduleId)) {
            setScheduleId(location.state.scheduleId);
        }
        else if (isValid(location.search)) {
            const queryParams = getUrlVars(location.search)
            setScheduleId(queryParams.scheduleId)
        }
    }, [location])

    return (
        <div className="manual-trip-page-root">
            <EasyTripCreateComponent
                scheduleId={scheduleId}
            />
        </div>
    )
}